import dayjs from 'dayjs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Link as MUILink, Tooltip, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';

type TitleProps = {
  firstName: string;
  lastName: string;
  dateCreated: string;
  module: string;
  moduleID: string;
};

const Title: FC<TitleProps> = ({
  firstName,
  lastName,
  dateCreated,
  module,
  moduleID,
}) => {
  const { t } = useTranslation(['notes', 'common']);

  return (
    <Box display='flex' alignItems='center'>
      <Tooltip
        title={
          <Typography variant='body2' color='text.primary'>
            {firstName} {lastName}
          </Typography>
        }
        placement='top'
        arrow
      >
        <Typography
          variant='body2'
          fontWeight='500'
          noWrap
          sx={{
            mr: 0.5,
            minWidth: 20,
          }}
        >
          {firstName} {lastName}
        </Typography>
      </Tooltip>

      <Typography variant='body2' color='text.secondary' sx={{ mr: 0.5 }}>
        {t('notes:noteOn')}
      </Typography>

      <Tooltip
        title={
          <Stack direction='row' spacing={1}>
            <Typography variant='body2' color='text.primary'>
              {t(`common:${module}`)}:
            </Typography>
            <Typography variant='body2' color='text.secondary'>
              {moduleID.split('-')[0]}
            </Typography>
          </Stack>
        }
        placement='top'
        arrow
      >
        <MUILink
          href={`/${module}/${moduleID}`}
          target='_blank'
          color='text.secondary'
          variant='body2'
          sx={{
            textTransform: 'lowercase',
            mr: 1,
          }}
        >
          {t(`common:${module}`)}
        </MUILink>
      </Tooltip>

      <Tooltip
        title={dayjs(dateCreated).format('YYYY-MM-D h:mm:ss A')}
        placement='top'
        arrow
      >
        <Typography
          variant='body2'
          color='text.secondary'
          sx={{
            marginLeft: 'auto',
            flexShrink: 0,
          }}
        >
          {dayjs(dateCreated).format('YYYY-MM-D h:mm A')}
        </Typography>
      </Tooltip>
    </Box>
  );
};

export default Title;
